import { useEffect, useMemo, useState } from "react";
import axios from "axios";

const BASE_URL = "https://nissi-india.com";

function qs(name) {
  return new URLSearchParams(window.location.search).get(name) || "";
}

function n(x) {
  const v = Number(String(x ?? "").replace(/,/g, ""));
  return Number.isFinite(v) ? v : 0;
}

function fmt2(x) {
  const v = n(x);
  return v.toFixed(2);
}

// Try multiple keys (because SP may return different column names)
function pick(row, keys, def = "") {
  for (const k of keys) {
    if (row && row[k] !== undefined && row[k] !== null && String(row[k]).trim() !== "") return row[k];
  }
  return def;
}

const BonusMasterListPrint = () => {
  const finYearId = qs("finYearId") || localStorage.getItem("finYearId") || "";

  // filters (same as main page)
  const radio = qs("radio") || "Salary"; // not used for this layout, but keep same endpoint
  const empCode = qs("empCode") || "";
  const empName = qs("empName") || "";
  const siteId = qs("siteId") || "Select";
  const payment = qs("payment") || "Select";
  const deptId = qs("deptId") || "Select";
  const year = qs("year") || "";
  const fromDate = qs("fromDate") || "";
  const toDate = qs("toDate") || "";
  const tdsLimit = qs("tdsLimit") || "Select";

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState({ yearFrom: "", yearTo: "" });

  // Fixed month columns exactly like screenshot
  const monthCols = useMemo(
    () => [
      { key: "Oct", label: "Oct", keys: ["Oct", "October"] },
      { key: "Nov", label: "Nov", keys: ["Nov", "November"] },
      { key: "Dec", label: "Dec", keys: ["Dec", "December"] },
      { key: "Jan", label: "Jan", keys: ["Jan", "January"] },
      { key: "Feb", label: "Feb", keys: ["Feb", "February"] },
      { key: "Mar", label: "Mar", keys: ["Mar", "March"] },
      { key: "Apr", label: "Apr", keys: ["Apr", "April"] },
      { key: "May", label: "May", keys: ["May"] },
      { key: "June", label: "June", keys: ["Jun", "June"] },
      { key: "July", label: "July", keys: ["Jul", "July"] },
      { key: "Aug", label: "Aug", keys: ["Aug", "August"] },
      { key: "Sep", label: "Sep", keys: ["Sep", "September"] },
    ],
    []
  );

  // Totals columns (as screenshot)
  const totalCol = useMemo(
    () => ({
      total: { label: "Total", keys: ["Total"] },
      bonus: { label: "Bonus 12.5/6.25", keys: ["Bonus", "Bonus(12.5/6.25)", "Bonus 12.5/6.25"] },
      batta: { label: "Batta", keys: ["Batta"] },
      battaBonus: { label: "Batta Bonus", keys: ["Batta Bonus", "BattaBonus"] },
      totalBonus: { label: "Total Bonus", keys: ["Total Bonus", "TotalBonus"] },
      location: { label: "Location", keys: ["Location"] },
    }),
    []
  );

  const totals = useMemo(() => {
    let tTotal = 0;
    let tBonus = 0;
    let tBatta = 0;
    let tBattaBonus = 0;
    let tTotalBonus = 0;

    for (const r of rows) {
      tTotal += n(pick(r, totalCol.total.keys, 0));
      tBonus += n(pick(r, totalCol.bonus.keys, 0));
      tBatta += n(pick(r, totalCol.batta.keys, 0));
      tBattaBonus += n(pick(r, totalCol.battaBonus.keys, 0));
      tTotalBonus += n(pick(r, totalCol.totalBonus.keys, 0));
    }

    return {
      tTotal,
      tBonus,
      tBatta,
      tBattaBonus,
      tTotalBonus,
    };
  }, [rows, totalCol]);

  const fetchPrintData = async () => {
    if (!String(finYearId).trim()) return;

    try {
      setLoading(true);
      const res = await axios.get(`${BASE_URL}/api/yearly-batta-salary-scale/print-data`, {
        params: {
          finYearId: Number(finYearId),
          radio,
          empCode,
          empName,
          siteId,
          payment,
          deptId,
          year,
          fromDate,
          toDate,
          tdsLimit,
        },
      });

      if (res?.data?.success) {
        setRows(res.data.rows || []);
        setMeta(res.data.meta || { yearFrom: "", yearTo: "" });

        // auto print
        setTimeout(() => window.print(), 300);
      }
    } catch (e) {
      // keep silent in print; you can add toast if you want
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const yearFrom = meta.yearFrom || (year ? String(year) : "----");
  const yearTo = meta.yearTo || (year ? String(Number(year) + 1) : "----");

  return (
    <div className="printWrap">
      {/* no toolbar in print */}
      <div className="noPrint tools">
        <button onClick={() => window.print()} disabled={loading}>
          Print
        </button>
        <button onClick={() => window.close()}>Close</button>
      </div>

      <div className="sheet">
        {/* Header */}
        <div className="outerBox">
          <div className="topRow">
            <div className="logoBox">
              {/* Use your real logo path here if needed */}
              <img
                src="https://infrafinacial1.infraconsoft.net/theme1/images/SRC%20Logo.png"
                alt="logo"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>

            <div className="companyBox">
              <div className="companyName">Nissi Infotech</div>
              <div className="subName">Nissi</div>
              <div className="subNameBold">CIVIL CONSTRUCTION</div>

              <div className="addr">
                3/42-12, Nagappa colony , kavundampalayam 641030 . Tamil Nadu . India .
              </div>
              <div className="addr">
                Phone No : 9003744644 &nbsp;&nbsp;&nbsp;&nbsp; infraconsoft-implementation@nissi
              </div>
            </div>
          </div>

          <div className="hr" />

          <div className="title">
            BONUS MASTER LIST FOR THE YEAR OF {yearFrom} &nbsp; TO &nbsp; {yearTo}
          </div>

          {/* Table */}
          <table className="tbl">
            <thead>
              <tr>
                <th style={{ width: 45 }}>SNo</th>
                <th style={{ width: 70 }}>Code</th>
                <th style={{ width: 170 }}>Employee Name</th>
                <th style={{ width: 120 }}>Designation</th>
                <th style={{ width: 90 }}>DOJ</th>
                <th style={{ width: 110 }}>A/C No.</th>

                {monthCols.map((m) => (
                  <th key={m.key} style={{ width: 60 }}>
                    {m.label}
                  </th>
                ))}

                <th style={{ width: 70 }}>{totalCol.total.label}</th>
                <th style={{ width: 90 }}>{totalCol.bonus.label}</th>
                <th style={{ width: 70 }}>{totalCol.batta.label}</th>
                <th style={{ width: 90 }}>{totalCol.battaBonus.label}</th>
                <th style={{ width: 90 }}>{totalCol.totalBonus.label}</th>
                <th style={{ width: 90 }}>{totalCol.location.label}</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={6 + monthCols.length + 6} className="noRec">
                    No Records Found
                  </td>
                </tr>
              ) : (
                rows.map((r, i) => {
                  const code = pick(r, ["Code", "EmployeeCode", "EmpCode", "fld_Employeecode"], "");
                  const name = pick(r, ["Employee Name", "EmployeeName", "EmpName", "fld_Employee"], "");
                  const desig = pick(r, ["Designation"], "");
                  const doj = pick(r, ["DOJ"], "");
                  const acno = pick(r, ["A/C No.", "AC No", "A/C No", "AccountNo", "A_C_No"], "");

                  return (
                    <tr key={i}>
                      <td className="center">{i + 1}</td>
                      <td className="center">{code}</td>
                      <td className="left">{name}</td>
                      <td className="left">{desig}</td>
                      <td className="center">{doj}</td>
                      <td className="center">{acno}</td>

                      {monthCols.map((m) => (
                        <td key={m.key} className="center">
                          {pick(r, m.keys, "")}
                        </td>
                      ))}

                      <td className="center">{pick(r, totalCol.total.keys, "")}</td>
                      <td className="center">{pick(r, totalCol.bonus.keys, "")}</td>
                      <td className="center">{pick(r, totalCol.batta.keys, "")}</td>
                      <td className="center">{pick(r, totalCol.battaBonus.keys, "")}</td>
                      <td className="center">{pick(r, totalCol.totalBonus.keys, "")}</td>
                      <td className="center">{pick(r, totalCol.location.keys, "")}</td>
                    </tr>
                  );
                })
              )}
            </tbody>

            {/* Footer row like screenshot: "Total Bonus(Rs)" + totals */}
            {rows.length > 0 && (
              <tfoot>
                <tr>
                  {/* first 6 columns empty */}
                  <td colSpan={6} />

                  {/* label spans all month columns */}
                  <td colSpan={monthCols.length} className="footLabel">
                    Total Bonus(Rs)
                  </td>

                  {/* totals at end */}
                  <td className="center bold">{fmt2(totals.tTotal)}</td>
                  <td className="center bold">{fmt2(totals.tBonus)}</td>
                  <td className="center bold">{fmt2(totals.tBatta)}</td>
                  <td className="center bold">{fmt2(totals.tBattaBonus)}</td>
                  <td className="center bold">{fmt2(totals.tTotalBonus)}</td>
                  <td />
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      <style>{`
        .printWrap { background:#fff; color:#000; font-family:"Times New Roman", Times, serif; }
        .tools { padding:10px; display:flex; gap:10px; }
        .tools button { padding:8px 14px; border:1px solid #000; background:#000; color:#fff; font-weight:700; border-radius:8px; cursor:pointer; }
        .tools button:last-child { background:#fff; color:#000; }
        
        .sheet { display:flex; justify-content:center; }
        .outerBox { width: 1400px; border:2px solid #000; padding:12px; }

        .topRow { display:flex; align-items:flex-start; gap:14px; }
        .logoBox { width:220px; height:120px; display:flex; align-items:center; justify-content:center; border:1px solid #000; }
        .logoBox img { max-width:210px; max-height:110px; }

        .companyBox { flex:1; text-align:center; }
        .companyName { font-weight:800; font-size:18px; }
        .subName { font-size:14px; font-weight:700; margin-top:2px; }
        .subNameBold { font-size:14px; font-weight:800; margin-top:2px; }
        .addr { font-size:12px; margin-top:2px; }

        .hr { border-top:1px solid #000; margin:10px 0; }

        .title { text-align:center; font-weight:800; font-size:13px; margin: 6px 0 10px; }

        .tbl { width:100%; border-collapse:collapse; font-size:11px; }
        .tbl th, .tbl td { border:1px solid #000; padding:4px 5px; vertical-align:middle; }
        .tbl th { font-weight:800; text-align:center; }
        .center { text-align:center; }
        .left { text-align:left; }
        .bold { font-weight:800; }
        .noRec { padding:18px; text-align:center; font-weight:800; }
        .footLabel { text-align:center; font-weight:800; }

        @media print {
          .noPrint { display:none !important; }
          @page { size: A4 landscape; margin: 8mm; }
          .outerBox { width:auto; }
        }
      `}</style>
    </div>
  );
};

export default BonusMasterListPrint;
